// src/services/bookingService.js

import apiClient from "./apiClient";

// Use centralized API client for consistent error handling
const api = apiClient;


export function getBookingsByRoom(roomId) {
  return api.get(`/api/bookings/room/${roomId}`).then(res => res.data);
}

export function createBooking(data) {
  // Add client timezone information for proper backend conversion
  const bookingData = {
    ...data,
    clientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
  };
  return api.post("/api/bookings", bookingData).then(res => res.data);
}

export async function getFreeSlots(roomId, dateStr) {
  // dateStr in format "YYYY-MM-DD"
  const res = await api.get(`/api/rooms/${roomId}/freeSlots?date=${dateStr}`);
  return res.data; // array of half-hour strings
}

export async function getMyBookings() {
    const res = await api.get("/api/bookings/my");
    return res.data;
  }
  
  export async function cancelMyBooking(bookingId) {
    const res = await api.delete(`/api/bookings/my/${bookingId}`);
    return res.data;
  }

  // Update/edit a booking - only the booking owner can edit their booking, admin can migrate any booking
  export async function updateBooking(bookingId, { startTime, endTime, roomId, meetingName }) {
    // Add client timezone information for proper backend conversion
    const bookingData = {
      startTime,
      endTime,
      clientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    // Add roomId if provided (for booking migration)
    if (roomId) {
      bookingData.roomId = roomId;
    }

    // Add meetingName if provided
    if (meetingName !== undefined) {
      bookingData.meetingName = meetingName;
    }

    const res = await api.put(`/api/bookings/${bookingId}`, bookingData);
    return res.data;
  }

  // get all bookings in the org for an admin
export async function getAllBookingsAdmin() {
    // same endpoint as getAllBookings, but the server logic checks if user is in an org and if user can see it.
    const res = await api.get("/api/bookings"); 
    return res.data;
  }
  
  // cancel any booking by admin
  export async function cancelAnyBookingAdmin(bookingId) {
    // new route in the server for admin to delete/cancel a booking
    const res = await api.delete(`/api/bookings/admin/${bookingId}`);
    return res.data;
  }